module.exports = __webpack_public_path__ + "static/img/cuerpo_humano.09593ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cuerpo_humano.jpg
// module id = tk/j
// module chunks = 2